export default __webpack_public_path__ + "static/media/ivan_sucharski.a6a644ee.png";